import { buildCombinationKey, cartesianProduct } from "@simplyk/common";

import { ShopVariantData, VariantSeatData } from "@/features/LiveFormEditor/Steps/StepTickets/Rates/types";

export const getVariantItemCapacity = ({
  shopVariants,
  variantSeats,
  soldCount,
}: {
  shopVariants: ShopVariantData[] | undefined;
  variantSeats: VariantSeatData[] | undefined;
  soldCount: number;
}): number | null | undefined => {
  const valueIdSets = (shopVariants ?? [])
    .map((variant) => variant.values.map((value) => value.id))
    .filter((valueIds) => valueIds.length > 0);
  if (valueIdSets.length === 0) {
    return undefined;
  }

  const variantSeatsByKey = new Map((variantSeats ?? []).map((entry) => [entry.combinationKey, entry]));
  const combinationSeats = cartesianProduct(valueIdSets).map((combination) =>
    variantSeatsByKey.get(buildCombinationKey(combination))
  );
  if (combinationSeats.some((variantSeat) => variantSeat?.seats === null || variantSeat?.seats === undefined)) {
    return null;
  }
  const remainingStock = combinationSeats.reduce(
    (total, variantSeat) => total + Math.max((variantSeat?.seats ?? 0) - (variantSeat?.soldCount ?? 0), 0),
    0
  );
  return soldCount + remainingStock;
};
